import type { SetCableTypeNameStatusInPlan } from "./types";

export const setCableTypeNameStatusInPlan: SetCableTypeNameStatusInPlan = ({
  plan,
  routeTypeIds,
  cableTypeStatus,
}) => {
  if (routeTypeIds.length === 0) return plan;
  const targetIds = new Set(routeTypeIds);

  let didChange = false;
  const routeGroups = plan.routeGroups.map((group) => {
    if (
      !targetIds.has(group.route_type_id) ||
      group.cableTypeStatus === cableTypeStatus
    ) {
      return group;
    }
    didChange = true;
    return { ...group, cableTypeStatus };
  });

  if (!didChange) return plan;
  return { ...plan, routeGroups };
};
